import React from "react";
import UploadIcon from "@atlaskit/icon/glyph/upload";

import { IPlacementWorksheetUnit } from "../../services/PlacementWorksheetApi";
import { Button } from "../../UI/Button";
import { useModalContext } from "../../contexts/ModalContext/context";
import { UploadUnitNumbersModal } from "./UploadUnitNumbersModal";

interface IProps {
  filteredData: IPlacementWorksheetUnit[];
  refetchData: () => Promise<void>;
}

export const UploadUnitNumbersButton: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();

  const openModal = () => setIsOpen(true);

  return (
    <>
      <Button appearance="primary" iconBefore={<UploadIcon label="upload" />} onClick={openModal}>
        Upload List of Unit Numbers
      </Button>
      <UploadUnitNumbersModal filteredData={props.filteredData} onSuccess={props.refetchData} />
    </>
  );
};
